import { render } from "./cpt-g6-dom-option.vue?vue&type=template&id=394fe36e"
import script from "./cpt-g6-dom-option.vue?vue&type=script&lang=js"
export * from "./cpt-g6-dom-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__